module.exports = __webpack_public_path__ + "static/media/DomBarra_FucktheSystem.901d5750.mp4";